<div class="search-container">
    <div class="search-field input-group">
        <input #searchField (blur)="store()" (change)="searchQuery()"
               (keyup)="keyUp($event)"
               [(ngModel)]="searchText" class="input-field form-control" placeholder="Beispiele, Texte, Notizen" type="text"/>
        <span class="input-group-btn last-input">
            <button (click)="enter()" class="btn btn-default"><span class="fa fa-angle-double-right"></span></button>
        </span>
    </div>

    <div class="search-result-container">
        @if (searchText.length > 0) {
            <div class="search-result-container-scroll">
                @if (quickLinkResults && showExercises) {
                    <div>
                        <div class="content-description">
                            Beispiele
                        </div>
                        <div class="search-results-scroll">
                            <div class="search-results">
                                <ul>
                                    @for (result of quickLinkResults; track result) {
                                        <li>
                                            <search-item [searchResult]="result"
                                                         [searchText]="searchText"></search-item>
                                        </li>
                                    }
                                </ul>
                            </div>
                            @if (!quickLinkResults || quickLinkResults.length <= 0) {
                                <i>
                                    Es wurden keine Beispiele gefunden die dieser Suchanfrage entsprechen.
                                </i>
                            }
                        </div>
                    </div>
                }
                @if (noteResults && showTexts) {
                    <div>
                        <div class="content-description">
                            Notizen
                        </div>
                        <div class="search-results-scroll">
                            <div class="search-results">
                                <ul>
                                    @for (result of noteResults; track result) {
                                        <li>
                                            <search-item [searchResult]="result"
                                                         [searchText]="searchText"></search-item>
                                        </li>
                                    }
                                </ul>
                            </div>
                            @if (!noteResults || noteResults.length <= 0) {
                                <i>
                                    Es wurden keine Notizen gefunden die dieser Suchanfrage entsprechen.
                                </i>
                            }
                        </div>
                    </div>
                }
                @if (chapterResults && chapterResults.length > 0) {
                    <div>
                        <div class="content-description">
                            Kapitel
                        </div>
                        <div class="search-results-scroll">
                            <div class="search-results">
                                <ul>
                                    @for (result of chapterResults; track result) {
                                        <li>
                                            <search-item [searchResult]="result"
                                                         [searchText]="searchText"></search-item>
                                        </li>
                                    }
                                </ul>
                            </div>
                            @if (!chapterResults || chapterResults.length <= 0) {
                                <i>
                                    Es wurden keine Kapitel gefunden die dieser Suchanfrage entsprechen.
                                </i>
                            }
                        </div>
                    </div>
                }
                @if (searchResults && searchResults.length > 0) {
                    <div>
                        <div class="content-description">
                            Texte im Buch
                        </div>
                        <div class="search-results-scroll">
                            <div class="search-results">
                                <ul>
                                    @for (result of searchResults; track result) {
                                        <li>
                                            <search-item [searchResult]="result"
                                                         [searchText]="searchText"></search-item>
                                        </li>
                                    }
                                </ul>
                            </div>
                            @if (!searchResults || searchResults.length <= 0) {
                                <i>
                                    Es wurden keine Ergebnisse gefunden die dieser Suchanfrage entsprechen.
                                </i>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>

    @if (searchText.length < 1) {
        <div>
            <div class="search-info">
                <h6>Suchen sie nach ...</h6>
                <ul>
                    <li>Beispielnummern</li>
                    <li>Notizen</li>
                    <li>Kapitelnummern</li>
                    <li>Buchtexten</li>
                </ul>
            </div>
            <div class="search-history">
                <div class="content-description">
                    Meine letzten Suchanfragen
                </div>
                <ul class="search-history-list">
                    @for (history of searchHistory; track history) {
                        <li (click)="fillSearchField(history)"
                            class="search-history-item"
                        >
                            <button (click)="fillSearchField(history)">
                                <span class="search-text">{{ history.text }}</span> <span
                                    class="search-date">{{ history.date | date:'dd.MM.yyyy' }}</span>
                            </button>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</div>
